import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetLoggedInUserQuery } from "../toolkitServices/userApi";
import { setUser, clearUser } from "../slices/authSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import AppLoader from "../components/AppLoader";

const AuthGate = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
const { data, isFetching:isLoading, isError:error } = useGetLoggedInUserQuery(undefined, {
  refetchOnMountOrArgChange: true,
});  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (data?.success) {
      dispatch(setUser(data.data));
    } else if (error) {
      dispatch(clearUser());
      toast.error("Session expired or failed to login.");
      navigate("/login");
    }
  }, [data, error, dispatch, navigate]);

  if (isLoading) return <AppLoader />;

  if (!isAuthenticated || !user) return null;

  return children;
};

export default AuthGate;
